import React from 'react';

import css from './ExampleModuleLayout.scss';

export default () => {
    return (
        <div className={css.exampleModuleContainer}>
            <h1>BMW Lifestyle</h1>
            <p />
            <p />
            <h3>Módulo de Exemplo</h3>
            <p />
            <p>Esta página serve apenas para exemplificar um novo módulo a incluir na aplicação Prime.</p>
        </div>
    );
};
